import { useState } from 'react';
import { ClearFiltersButton } from '../../components/clearFiltersButton.tsx';
import { NavBar } from '../../components/navBar.tsx';
import { PageTitle } from '../../components/pageTitle.tsx';
import { RecordsExportDialog } from '../../components/records-export/recordsExportDialog.tsx';
import { useLoadMoreOnScroll } from '../../hooks/useLoadMoreOnScroll.ts';
import { useRecordsFilters } from '../../hooks/useRecordsFilters.ts';
import { Record } from '../../types/sharedTypeImpl.ts';
import { trpc, trpcClient } from '../../utils/trpc/trpc.ts';
import { RecordListTable } from './recordListTable.tsx';


export function RecordList() {
    const [pendingExportRecord, setPendingExportRecord] = useState<Record | null>(null);

    const {
        searchTextInput,
        searchText,
        setSearchTextDebounced,
        setSearchTextImmediate,
        onlyWithIssues,
        setOnlyWithIssues,
        handleClearFilters,
    } = useRecordsFilters();


    const recordsQuery = trpc.records.getInfinite.useInfiniteQuery({
        measurementType: 'production',
        search: searchText,
        limit: 50,
        onlyWithIssues,
    }, {
        getNextPageParam: (last) => last.nextCursor ?? null,
        placeholderData: (prev) => prev,//Prevents flickering when editing filters
    });

    useLoadMoreOnScroll(recordsQuery);


    const handleRecordDelete = async (record: Record) => {
        const description = `${record.equipmentDisplayName} - ${record.protocolPartDisplayName}`;
        if (window.confirm(`Are you sure you want to delete the following record?\n${description}`)) {
            try {
                await trpcClient.records.delete.mutate({ recordId: record._id!, deleteMeasurement: true });
                recordsQuery.refetch();
            } catch (error) {
                alert('Failed to delete record');
            }
        }
    }

    const handleRecordsExport = async function (record: Record) {
        if (!record.orderNumber) {
            alert('Cannot export records without an order number');
        } else {
            setPendingExportRecord(record);
        }
    };


    const records = recordsQuery.data?.pages.flatMap(page => page.records) ?? [];
    return (
        <>
            <PageTitle title='Records' />
            <NavBar />
            <div className='content' style={{ width: '1480px', marginBottom: '20px' }}>
                <div style={{ display: 'flex', justifyContent: 'right', alignItems: 'center' }}>
                    <label className='with-checkbox'>
                        Show issues only
                        <input
                            style={{ marginLeft: '8px' }}
                            type='checkbox'
                            checked={onlyWithIssues}
                            onChange={e => setOnlyWithIssues(e.target.checked)}
                        />
                    </label>
                    <input
                        style={{ marginLeft: '18px' }}
                        type='text'
                        placeholder='Search'
                        value={searchTextInput}
                        onChange={e => setSearchTextDebounced(e.target.value)}
                    />
                    <ClearFiltersButton onClick={handleClearFilters} />
                </div >

                <RecordListTable
                    isLoading={recordsQuery.isLoading}
                    error={recordsQuery.error}
                    records={records}
                    onRecordDelete={handleRecordDelete}
                    onRecordsExport={handleRecordsExport}
                    onSearchTextChange={setSearchTextImmediate}
                />

                {recordsQuery.hasNextPage && (
                    <div className='list--loading-more'>Loading…</div>
                )}
            </div>

            {pendingExportRecord && <RecordsExportDialog
                record={pendingExportRecord}
                onClose={() => setPendingExportRecord(null)}
            />}
        </>
    );
}
